import Input, { Props } from '@storeblocks/input/lib';
import React from 'react';

export const TextArea = (props: Props): React.ReactElement => {
  return <Input as="textarea" {...props} />;
};
